// src/pages/ContactoMobile.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/api'; 

const COLOR_SIERRA_GREEN = '#2E5B2E'; 
const COLOR_CANTERA_PINK = '#C19A6B';
const COLOR_WHITE = '#FFFFFF';
const COLOR_CHARCOAL = '#333333';

function ContactoMobile() {
    const navigate = useNavigate();
    
    const [formData, setFormData] = useState({
        nombre: '',
        email: '',
        mensaje: ''
    });
    
    const [enviado, setEnviado] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await api.post('/contact', formData);
            
            setEnviado(true);
            
            setTimeout(() => {
                navigate('/');
            }, 3000);

        } catch (error) {
            console.error("Error enviando mensaje", error);
            alert("Hubo un problema al enviar el mensaje. Intenta nuevamente.");
        } finally {
            setLoading(false);
        }
    };

    const PAGE_CONTAINER = { 
        minHeight: '100vh', 
        background: COLOR_SIERRA_GREEN, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'flex-start',
        padding: '20px 0',
        position: 'relative',
        overflow: 'hidden'
    };
    
    const navBarButtonStyle = { 
        background: 'transparent', 
        color: COLOR_WHITE, 
        padding: '8px 15px', 
        borderRadius: 20, 
        border: `1px solid ${COLOR_WHITE}50`, 
        fontWeight: 'bold',
        cursor: 'pointer',
        textDecoration: 'none',
        fontSize: 14
    };

    const formCardStyle = { 
        width: '90%',
        maxWidth: 500, 
        background: COLOR_WHITE, 
        borderRadius: 16, 
        padding: 30, 
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        zIndex: 10, 
        color: COLOR_CHARCOAL 
    };
    
    const titleBoxStyle = {
        background: COLOR_SIERRA_GREEN, 
        color: COLOR_WHITE, 
        padding: '20px 0 15px 0',
        width: 'calc(100% + 60px)', // Para que cubra el ancho de la tarjeta
        margin: '-30px -30px 20px -30px',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 24,
    };


    const inputStyle = { 
        width: '100%', 
        padding: 12, 
        marginBottom: 20, 
        borderRadius: 5, 
        background: COLOR_WHITE, 
        fontSize: 16, 
        border: `1px solid ${COLOR_CANTERA_PINK}`,
        color: COLOR_CHARCOAL,
    };
    
    const submitButtonStyle = { 
        width: '100%', 
        background: loading ? COLOR_CANTERA_PINK : COLOR_SIERRA_GREEN, 
        color: COLOR_WHITE, 
        padding: 15, 
        borderRadius: 8, 
        fontWeight: 'bold', 
        fontSize: 18, 
        border: 'none', 
        marginTop: 15,
        cursor: loading ? 'not-allowed' : 'pointer',
    };
    
    const labelStyle = { 
        marginBottom: 5, 
        display: 'block', 
        fontWeight: 'bold', 
        color: COLOR_CHARCOAL,
        fontSize: 14 
    };
    
    const contactDetailStyle = {
        display: 'flex', 
        alignItems: 'center', 
        gap: 10, 
        marginBottom: 15,
        fontSize: 14
    };
    
    const successStyle = {
        textAlign: 'center',
        padding: 20,
        color: COLOR_SIERRA_GREEN
    }


    return (
        <div style={PAGE_CONTAINER}>
            <div style={{ width: '90%', maxWidth: 500, display: 'flex', justifyContent: 'flex-end', alignItems:'center', marginBottom: 20, zIndex: 10 }}>
                <Link to="/" style={navBarButtonStyle}>Inicio</Link>
            </div>
            
            <div style={formCardStyle}>
                
                <div style={titleBoxStyle}>
                    <div>CONTÁCTANOS</div>
                    <div style={{fontSize: 14, fontWeight: 'normal', marginTop: 5}}>
                        Llevemos el mejor café a tu negocio.
                    </div>
                </div>
                
                {enviado ? (
                    <div style={successStyle}>
                        <h3 style={{marginTop:0}}>¡Mensaje Enviado! ✅</h3>
                        <p>Te responderemos a la brevedad.</p>
                        <small>Redirigiendo al inicio...</small>
                    </div>
                ) : (
                    <div style={{ width: '100%' }}>
                        
                        {/* DATOS DE CONTACTO (Arriba del Formulario) */}
                        <div style={{marginBottom: 20, borderBottom: `1px solid ${COLOR_CANTERA_PINK}30`, paddingBottom: 15}}>
                            <h4 style={{color: COLOR_SIERRA_GREEN, marginBottom: 15, fontSize: 18}}>Datos de Contacto</h4>
                            
                            <div style={contactDetailStyle}>
                                <span role="img" aria-label="phone" style={{color: COLOR_CANTERA_PINK, fontSize: 18}}>📞</span>
                                <div>
                                    <div style={{fontWeight: 'bold'}}>Ventas QRO: (442) 614-1234</div>
                                </div>
                            </div>
                            
                            <div style={contactDetailStyle}>
                                <span role="img" aria-label="email" style={{color: COLOR_CANTERA_PINK, fontSize: 18}}>✉️</span>
                                <div>
                                    <div style={{fontWeight: 'bold'}}>Email B2B: contacto.xavana@gmail.com</div>
                                </div>
                            </div>
                        </div>

                        {/* FORMULARIO */}
                        <form onSubmit={handleSubmit} style={{ flex: 1 }}>
                            <label style={labelStyle}>Nombre Completo</label>
                            <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} style={inputStyle} required placeholder="Tu nombre" />
                            
                            <label style={labelStyle}>Correo Electrónico</label>
                            <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyle} required placeholder="contacto@ejemplo.com" />
                            
                            <label style={labelStyle}>Mensaje</label>
                            <textarea name="mensaje" value={formData.mensaje} onChange={handleChange} style={{ ...inputStyle, minHeight: 100, resize: 'vertical', fontFamily: 'inherit' }} required placeholder="Escribe tu mensaje aquí..." />
                            
                            <button type="submit" disabled={loading} style={submitButtonStyle}>
                                {loading ? 'Enviando...' : 'ENVIAR MENSAJE'}
                            </button>
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ContactoMobile;